export const subOrderSurfaceSx = {
    width: '100%',
    p: {xs: 1.5, sm: 2},
    bgcolor: 'background.paper',
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 2,
    boxShadow: '0 2px 10px rgba(28, 28, 28, 0.025)',
};

export const subOrderEditorSx = {
    mt: 2,
    pt: 2,
    borderTop: '1px solid',
    borderColor: 'divider',
};

export const subOrderSelectorSx = {
    display: 'grid',
    gridTemplateColumns: {xs: 'minmax(0, 1fr) 60px 44px', sm: 'minmax(0, 1fr) 120px 44px'},
    gridTemplateAreas: '"name quantity action"',
    gap: 1,
    alignItems: 'center',
    width: '100%',
    minWidth: 0,
    p: 0,
    backgroundColor: 'transparent',
};

export const subOrderSelectorActionSx = {
    gridArea: 'action',
    width: 44,
    height: 44,
    minWidth: 44,
    minHeight: 44,
};
